import { ElementRef } from "@angular/core";

export type PreparedElementRef<T extends HTMLElement = HTMLElement> = Partial<{
  elementRef: ElementRef<T>;
  _elementRef: ElementRef<T>;
}>;
export type MaybeElementRef<T extends HTMLElement = HTMLElement> = PreparedElementRef<T> | ElementRef<T> | T;
export function getHTMLElement (ref: MaybeElementRef): HTMLElement {
  if (ref instanceof HTMLElement) return ref;

  if (ref instanceof ElementRef && ref.nativeElement instanceof HTMLElement) return ref.nativeElement;

  if ('elementRef' in ref && ref.elementRef.nativeElement instanceof HTMLElement)
    return ref.elementRef.nativeElement;

  if ('_elementRef' in ref && ref._elementRef.nativeElement instanceof HTMLElement)
    return ref._elementRef.nativeElement;

  throw new Error("Could not resolve HTMLElement from the given ref.");
}
